import { useQuery } from '@tanstack/react-query';

import { CoreBaseConfiguration } from './BaseConfiguration';
import {
  EMediaSequenceMutationTemplateType,
  MediaSequenceMutationTemplatesApi,
} from './core';

export const MediaSequenceMutationTemplateApiKeys = {
  SEARCH: 'media-sequence-mutation-templates-search',
};

const client = new MediaSequenceMutationTemplatesApi(
  new CoreBaseConfiguration()
);

export const useSearchMediaSequenceMutationTemplates = ({
  searchTerm,
  types,
}: {
  searchTerm?: string;
  types?: EMediaSequenceMutationTemplateType[];
}) => {
  return useQuery({
    queryKey: [MediaSequenceMutationTemplateApiKeys.SEARCH, searchTerm, types],
    queryFn: () =>
      client.mediaOrbitMediaSequenceMutationTemplatesSearchGet({
        size: 999, // TODO: Improve this at some point
        searchTerm,
        types,
      }),
    enabled: searchTerm !== undefined || searchTerm != '',
  });
};
